import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import envConfig from '../../../envConfig';
import { CrudType } from '../../../utility/types/CrudType';
import { CrudStatus } from '../../../utility/types/CrudStatus';

const selectUserListState = (state) => state.userList;

const selectUserList = createSelector(
  [selectUserListState],
  (userList) => userList.userList,
);

const selectUserListCrudStatus = (state) => state.userList.crudStatus;

const selectUserListCrudType = (state) => state.userList.crudOperation;

const selectUsersLoading = createSelector(
  [selectUserListCrudStatus],
  (crudStatus) => crudStatus === CrudStatus.PENDING,
);

const fetchScrubbedUsers = createAsyncThunk(
  'securedApi/userList/fetchScrubbedUsers',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${envConfig.raaUrl}/subscription/fetch-scrubbed-user-list`);
      return res.data.users;
    } catch (error) {
      return rejectWithValue({
        name: error.name,
        message: error.message,
        data: error.data,
      });
    }
  },
);

const initialState = {
  userList: [],
  crudOperation: CrudType.READ,
  crudStatus: CrudStatus.IDLE,
  error: {},
};

const userListSlice = createSlice({
  name: 'userList',
  initialState,
  reducers: {
    clearUserListSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchScrubbedUsers.pending, (state) => {
        state.crudOperation = CrudType.READ;
        state.crudStatus = CrudStatus.PENDING;
      })
      .addCase(fetchScrubbedUsers.fulfilled, (state, action) => {
        state.userList = action.payload;
        state.crudStatus = CrudStatus.IDLE;
      })
      .addCase(fetchScrubbedUsers.rejected, (state, action) => {
        state.crudStatus = CrudStatus.ERROR;
        state.error = [action.payload];
      });
  },
});

const { actions, reducer } = userListSlice;

export const { clearUserListSlice } = actions;

export {
  fetchScrubbedUsers,
  selectUserList,
  selectUserListCrudStatus,
  selectUserListCrudType,
  selectUsersLoading,
};

export default reducer;
